import Bindcomponent from "../utils/bindcomponent";
import Layout from "./Layout";
import { useMomHook } from "../hook/MomHook";
import { Box } from "@mui/material";
import { Save,SquarePlus,Search,FileArchive,TableOfContents,Table  } from "lucide-react";
import { FeedTwoTone, Help } from "@mui/icons-material";
import ConfirmationButton from "../components/ConfirmationButton";
import Helper from "./Helper";
 import { useParams } from "react-router-dom";
 import MomTable from "../components/MomTable";
 
const Mom = () =>{
    const {message,setmessage,typeError,setTypeError,momMonth,setMomMonth,momYear,setMomYear,momWeek,setMomWeek,
        yearList,monthList,weekList,setFind,find,rows,columns,openAdd,setOpenAdd,openEdit,setOpenEdit,setRows,handleSave,
        navigate,fetchData,updateId,toggle,setToggle,rolesAccess
    } = useMomHook()

    const {id} = useParams()
    console.log(rolesAccess)
    return (
        <>
          <Layout message={message} setmessage={setmessage} tipe={typeError} settipe={setTypeError}>
            <div className='pd'><b>MINUTES OF MEETING</b></div>
         
            <div className="pd" style={{height:"100%"}}>
                  {typeof id == "undefined" && (
                    <Box sx={{marginBottom:1, display:"flex", boxShadow:2, padding:1,paddingRight:1}}> 
                                    <button className='btn btn-warning btn-sm' title="M.O.M Archieve" onClick={() =>{
                                        navigate(`/Mom/Archieve${Helper.SetReturnUrl()}`)
                                       //window.location.href = `http://${window.location.host}/Mom/Archieve` + Helper.SetReturnUrl()
                                    }}  > <div style={{display:"flex", alignItems:"center",}}><FileArchive/>&nbsp;ARCHIEVE</div> </button>
                                    
                                </Box>
                  )}
                <Box sx={{height:"100%", boxShadow:2,padding:2,marginBottom:2}}>
               <div class="row mb-5">
                    <div class="col-md-3">
                        <label for="inputEmail4">Month</label>
                        <Bindcomponent component="StaticSelect" disabled={id=="Archieve" ? false : true} data={monthList} id="periodeMonth"  selectedvalue={momMonth} onChange={(e)=>setMomMonth(e.value)} placeholder="Enter Month" required></Bindcomponent>
                    </div>
                    <div class="col-md-3">
                        <label for="inputPassword4">Year</label>
                        <Bindcomponent component="StaticSelect" disabled={id=="Archieve" ? false : true} data={yearList} id="periodeYear"  selectedvalue={momYear} onChange={(e)=> setMomYear(e.value)} placeholder="Enter Year" required></Bindcomponent>
                    </div>
                    <div class="col-md-2">
                        <label for="inputPassword4">Week</label>
                        <Bindcomponent component="StaticSelect" disabled={id=="Archieve" ? false : true} data={weekList} id="periodeWeek"  selectedvalue={momWeek} onChange={(e) => setMomWeek(e.value)} placeholder="Enter Year" width="130" required></Bindcomponent>
                    </div>
                    {id != undefined && (
                    <div class="col-md-2 mt-11">
                        <label for="inputPassword4">&nbsp;</label>
                        <button className='btn btn-primary btn-sm' style={{height:35}} title="Search" onClick={async ()=>{
                            await fetchData(momWeek,momMonth,momYear)
                           // alert(momWeek)
                        }}><Search /></button>
                    </div>
                    )}
            </div>
            </Box>
           
                 <Box sx={{marginBottom:1, display:"flex", boxShadow:2, padding:1,paddingRight:1}}> 
                                    <button className='btn btn-danger btn-sm' onClick={(e) => setOpenAdd(true)} title="Add M.O.M"  ><div style={{display:"flex", alignItems:"center",}}><SquarePlus />&nbsp;ADD</div></button>
                                    <div style={{position:"absolute", right:45}}>
                                        
                                             {/* <button className='btn btn-primary btn-sm mr-2' >Archieve</button> */}
                                          <ConfirmationButton classname='btn btn-success btn-sm' text="Do you want save this data?" type="button" 
                                                               disabled={rolesAccess && !rolesAccess.CREATE} 
                                                                onClick={handleSave}
                                                               >
                                                                     <div style={{display:"flex", alignItems:"center",}}><Save />&nbsp;SAVE</div> 
                                                               </ConfirmationButton>
                                        {/* <button className='btn btn-success btn-sm' title="Save M.O.M" onClick={handleSave} ><Save /> </button> */}
                                    </div>
                                </Box>
           
           
            <div class="row">
               <div class="col-md-12">
                <Box sx={{height:"100%", boxShadow:2}}>
                  <div style={{display:"flex",marginBottom:10,paddingTop:10,paddingLeft:10}}>
                                        <div style={{display:"flex",marginRight:5}}> 
                                            <button className='btn btn-info btn-sm' title="View in Grid" onClick={(e) => setToggle(true)} ><TableOfContents /></button>
                                        </div>
                                        <div style={{display:"flex",marginRight:30}}> 
                                            <button className='btn btn-info btn-sm' title="View in Table" onClick={(e) => setToggle(false)}><Table /></button>
                                        </div>
                                        
                      </div>
                     {/* <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={searchJournal} name={"dailyjournalgrid"} rowid={"id"}></Bindcomponent>   */}
                     {toggle && (
                        <Bindcomponent component='GridCustomPaging' customcolumns={columns} rows={rows} name={"momGrid"} rowid={"id"} ></Bindcomponent>  
                     )}
                     
                         {/* <Bindcomponent component='DynamicDataGrid' customcolumns={columns} rows={searchJournal} name={"dailyjournalgrid"} rowid={"id"} ></Bindcomponent>   */}
                     {!toggle && (
                         <MomTable rows ={rows}></MomTable>
                     )}
                   
                </Box>
                </div> 
            </div>
           
            
            </div>
        
            <Bindcomponent component='Dialog' open={openAdd} setOpen={setOpenAdd} maxWidth='md' title={"CREATE M.O.M"} subtitle={""} >
                  <Bindcomponent component='MomAdd'  message={setmessage} rows={setRows} week={momWeek}  />   
            </Bindcomponent>

            <Bindcomponent component='Dialog' open={openEdit} setOpen={setOpenEdit} maxWidth='md' title={"CREATE M.O.M"} subtitle={""} >
                  <Bindcomponent component='MomEdit'  message={setmessage} setrows={setRows} rows={rows} id={updateId} onClose={() =>setOpenEdit(false)}/>   
            </Bindcomponent>
          
            {/* <Bindcomponent component='Dialog' open={confirmEditOpen} setOpen={setConfirmEditOpen} maxWidth='sm' title={"EDIT DAILY JOURNAL"} subtitle={""} >
                  <Bindcomponent component='DailyJournalEdit' data={data} setmessage={setmessage} close={setConfirmEditOpen} bind={async () => {
                        await HandleSearch(startDate,endDate); 
                        setmessage("Daily Journal was updated successfully")
                    }} />   
              
            </Bindcomponent>
          */}
            
          </Layout>
        </>
    )
    
}

export default Mom